<template>
  <b-overlay :show="loading" class="animated">
    <v-server-table
      id="prep-workflow-task-server-table"
      :ref="ref"
      :columns="table_config.columns"
      :options="table_config.options"
      :theme="theme"
      class="w-100"
    >

      <span slot="name" slot-scope="{row}">
        <b-link :to="`/${route_root}/${sample_type_id}/${prep_process_id}/${row.id}`">
          {{ row.name }}
        </b-link>
      </span>

      <span slot="group" slot-scope="{row}">
        <i v-if="row.group" class="fa fa-check text-success" />
        <i v-else class="fa fa-times text-muted" />
      </span>

      <span slot="actions" slot-scope="{ row }">
        <b-button v-if="checkPermission('edit prep task')" :to="`/${route_root}/${sample_type_id}/${prep_process_id}/${row.id}/edit`" variant="warning" class="px-1 py-0 text-white mr-1">
          <i class="fa fa-pencil" />
        </b-button>
      </span>

    </v-server-table>
  </b-overlay>
</template>

<script>
import Vue from 'vue'
import { ServerTable } from 'vue-tables-2'
import BaseServerTable from '@/components/shared/BaseServerTable'
import { AccessControlCheck } from '@/auth/AccessControlCheck'
import PrepTaskCollection from '@/collections/lab/PrepTaskCollection'
import { PrepWorkflowRoutes } from '@/router/lab/PrepWorkflowRoutes'

Vue.use(ServerTable)

export default {
  name: 'WorkflowPrepServerTable',
  extends: BaseServerTable,
  props: {
    collection: {
      type: Object,
      default: () => new PrepTaskCollection()
    },
    sample_type_id: {
      type: String,
      default: null
    },
    prep_process_id: {
      type: String,
      default: null
    },
    show_columns: {
      type: Array,
      default: () => [
        'name',
        'group',
        'actions'
      ]
    }
  },
  data () {
    return {
      table_config: Object.assign(this.getDefaultTableConfig(), {
        options: {
          headings: {
            name: 'Name',
            actions: 'Actions'
          }
        }
      })
    }
  },
  computed: {
    route_root () {
      return PrepWorkflowRoutes.fetchRoot()
    }
  },
  methods: {
    checkPermission (permission) {
      return AccessControlCheck.checkPermission(permission)
    },

    prepareCollectionFilter(filter) {
      filter.filterEquals('prep_process_id', this.prep_process_id)
    }
  }
}
</script>
